import './assets/main.css'
import './bootstrap'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import 'sweetalert2/dist/sweetalert2.min.css';
import CKEditor from '@ckeditor/ckeditor5-vue';
import VueSweetalert2 from 'vue-sweetalert2';
import App from './App.vue'
import router from './router'
import { createHead } from '@vueuse/head'
import piniaPersistedstate from 'pinia-plugin-persistedstate'
import { AppConstant } from '@/supports/app.constant'

const app = createApp(App)
const head = createHead()
const pinia = createPinia()
pinia.use(piniaPersistedstate)

app.use(pinia)
app.use(head)
app.use(router)
app.use(VueSweetalert2)
app.use(CKEditor)
app.config.globalProperties.$AppConstant = AppConstant
app.mount('#app')
